import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../app/GetProxy";
import { handleResponseCode } from "../../app/utilities/helpers";
const cookies = new Cookies();
const proxy = GetProxy(false);

export const backendConfig = createAsyncThunk("get/backendConfig", async () => {
  const res = await fetch(`${proxy}/initial/licence/getSetUpStatus`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "CMTS-API-TOKEN": "fkO9eqvBkAwC2jLDsMY9L7Cnm9TGJEsXDudllrWLfFI=",
    },
  }).then((resp) => resp.json());
  handleResponseCode(res);
  return res;
});
export const passwordConfig = createAsyncThunk(
  "get/passwordConfig",
  async () => {
    const res = await fetch(`${proxy}/initial/setupConfig`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "CMTS-API-TOKEN": "fkO9eqvBkAwC2jLDsMY9L7Cnm9TGJEsXDudllrWLfFI=",
      },
    }).then((resp) => resp.text());
    handleResponseCode(res);
    return res;
  }
);
export const licenseConfighome = createAsyncThunk(
  "get/licenseConfighome",
  async (props) => {
    const res = await fetch(`${proxy}/initial/licence/validation`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "CMTS-API-TOKEN": "fkO9eqvBkAwC2jLDsMY9L7Cnm9TGJEsXDudllrWLfFI=",
      },
      body: props,
    }).then((resp) => resp.text());
    handleResponseCode(res);
    return res;
  }
);
export const wizardConfighome = createAsyncThunk(
  "get/wizardConfighome",
  async (props) => {
    const { payload } = props;
    const res = await fetch(`${proxy}/initial/setupConfig/wizard`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "CMTS-API-TOKEN": "fkO9eqvBkAwC2jLDsMY9L7Cnm9TGJEsXDudllrWLfFI=",
      },
      body: JSON.stringify(payload),
    }).then((resp) => resp.text());
    handleResponseCode(res);
    return res;
  }
);

export const refreshTokenApi = createAsyncThunk(
  "get/refreshToken",
  async () => {
    const refreshToken = cookies.get("referstoken");
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");

    const res = await fetch(`${proxy}/refreshToken`, {
      method: "POST",
      headers: {
        Refreshtoken: refreshToken,
        "DTOP-API-TOKEN": Apitoken,
        USERNAME: User,
      },
    }).then((resp) => resp.json());
    return res;
  }
);

export const Homeapislice = createSlice({
  name: "homeapislice",
  initialState: {},

  reducers: {},
  extraReducers: (builder) => {
    builder
      //backendConfig
      .addCase(backendConfig.pending, (state, action) => {
        state.backendConfigLoding = true;
        state.apiError = false;
      })
      .addCase(backendConfig.fulfilled, (state, action) => {
        state.backendConfigData = action.payload;
        state.backendConfigLoding = false;
        state.apiError = false;
      })
      .addCase(backendConfig.rejected, (state, action) => {
        state.backendConfigLoding = false;
        state.backendConfigData = true;
        state.apiError = true;
      })
      //passwordConfig
      .addCase(passwordConfig.pending, (state, action) => {
        state.passwordConfigLoding = true;
        state.apiError = false;
      })
      .addCase(passwordConfig.fulfilled, (state, action) => {
        state.passwordConfigData = action.payload;
        state.passwordConfigLoding = false;
        state.apiError = false;
      })
      .addCase(passwordConfig.rejected, (state, action) => {
        state.passwordConfigLoding = false;
        state.passwordConfigData = [];
        state.apiError = true;
      })
      //licenseConfighome
      .addCase(licenseConfighome.pending, (state, action) => {
        state.licenseConfighomeLoding = true;
        state.apiError = false;
      })
      .addCase(licenseConfighome.fulfilled, (state, action) => {
        state.licenseConfighomeData = action.payload;
        state.licenseConfighomeLoding = false;
        state.apiError = false;
      })
      .addCase(licenseConfighome.rejected, (state, action) => {
        state.licenseConfighomeLoding = false;
        state.licenseConfighomeData = [];
        state.apiError = true;
      })
      //wizardConfighome
      .addCase(wizardConfighome.pending, (state, action) => {
        state.wizardConfighomeLoding = true;
        state.apiError = false;
      })
      .addCase(wizardConfighome.fulfilled, (state, action) => {
        state.wizardConfighomeData = action.payload;
        state.wizardConfighomeLoding = false;
        state.apiError = false;
      })
      .addCase(wizardConfighome.rejected, (state, action) => {
        state.wizardConfighomeLoding = false;
        state.wizardConfighomeData = [];
        state.apiError = true;
      });
  },
});

export default Homeapislice.reducer;
